import React, { useEffect, useState } from "react";
import {
  columnsStore,
  columnsDelivery,
} from "../../../constants/paymentsPayout";
import BasicCustomTable from "../../../component/basicTable/index";
import ButtonNavigationBar from "../../../component/buttonNavigationBar";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";
import { useDispatch } from "react-redux";
import { setPayoutsType } from "../../../Redux/Slices/counterSlice";
import {
  extractListFromResponse,
  formatPayoutMoney,
} from "../../../utils/paymentPayoutHelpers";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

function PaymentAndPayout() {
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const steps = ["Business Partner", "Delivery Partner"];
  const showSnackbar = useSnackbar();
  const [payouts, setPayouts] = useState([]);
  const [columns, setColumns] = useState(columnsStore);
  const [payoutType, setPayoutType] = useState("store_payout");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPayouts();
  }, [payoutType]);

  const fetchPayouts = () => {
    setLoading(true);
    axiosInstance
      .get(`/payment/summary?payout_type=${payoutType}`)
      .then((res) => {
        const rawUsers = extractListFromResponse(res?.data);
        const formattedUser = rawUsers.map((item) => ({
          storeName: item?.storeName ?? item?.name ?? "",
          id: item?.id ?? item?.store_id ?? item?.storeId,
          driverName: item?.name ?? item?.driverName ?? "",
          payoutCount:
            item?.payout_count ?? item?.payoutCount ?? item?.payouts_count ?? "—",
          totalSettle: formatPayoutMoney(
            item?.total_settled ?? item?.totalSettled ?? item?.total_settle
          ),
          paymentDue: formatPayoutMoney(
            item?.total_due ?? item?.totalDue ?? item?.payment_due
          ),
          totalFailed: formatPayoutMoney(
            item?.total_failed ?? item?.totalFailed ?? item?.total_failed_amount
          ),
        }));
        setPayouts(formattedUser);
        setColumns(payoutType === "store_payout" ? columnsStore : columnsDelivery);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
        setPayouts([]);
      })
      .finally(() => setLoading(false));
  };

  const handleSteps = (newValue) => {
    setActiveStep(newValue);
    const payoutMap = {
      0: "store_payout",
      1: "driver_payout",
    };
    setPayoutType(payoutMap[newValue] || "store_payout");
  };

  const handleView = (row) => {
    const name = row?.storeName || row?.driverName || "Unknown";
    dispatch(setPayoutsType(payoutType));
    try {
      sessionStorage.setItem("adminPayoutType", payoutType);
    } catch {
      /* ignore */
    }
    const encodedName = encodeURIComponent(name);
    navigate(`/app/payment&payout/payment-history/${row.id}?storename=${encodedName}`);
  };

  return (
    <div className="px-4 md:px-6 flex flex-col gap-5 pb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-2">
        <div className="flex items-center gap-3">
          <div className="relative flex items-center justify-center w-12 h-12 rounded-2xl bg-gradient-to-br from-[#3383B2]/12 to-[#3383B2]/5 text-[var(--primary-color)] border border-[#3383B2]/25 shadow-sm">
            <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 26 }} />
            <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-emerald-500 border-2 border-[var(--primary-bg-color)]" aria-hidden />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-[var(--primary-text-color)]">
              Payment &amp; Payout
            </h1>
            <p className="text-sm text-[var(--light-text-color)]">
              Summary of settlements and amounts due by partner type
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-[var(--table-border)] bg-[var(--primary-bg-color)] p-4 shadow-sm">
        <div className="w-full max-w-xl">
          <ButtonNavigationBar
            activeStep={activeStep}
            steps={steps}
            handleSteps={handleSteps}
          />
        </div>
        <p className="text-xs text-[var(--light-text-color)] mt-2">
          {activeStep === 0
            ? "Stores: total settled, payment due, total failed payouts, and payout count."
            : "Delivery partners: total settled, payment due, total failed payouts, and payout count."}
        </p>
      </div>

      {loading && payouts.length === 0 ? (
        <div className="rounded-2xl border border-[var(--table-border)] bg-[var(--primary-bg-color)] py-16 text-center text-sm text-[var(--light-text-color)]">
          Loading…
        </div>
      ) : (
        <BasicCustomTable
          columns={columns}
          rows={payouts}
          colorHeader={true}
          onView={handleView}
          customClassHeader="table-header-cell-colored"
          tableName="Payments"
          maxHeightClass="max-h-[calc(100vh-320px)]"
          frontendPagination={true}
          pageLimit={10}
        />
      )}
    </div>
  );
}

export default PaymentAndPayout;
